var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"points":"18 15 12 9 6 15"}));
}

ChevronUp.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-chevron-up"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
